import {
  faArrowDownToLine,
  faEllipsis,
} from "@fortawesome/pro-solid-svg-icons";

import type { GenerationTileAction } from "@/components/Tiles/GenerationTile/types";
import { Icon, TileButton, TileButtonsContainer } from "@/components/ui-v2";

interface MeshGenerationTileButtonsProps {
  onAction: (event: React.MouseEvent, action: GenerationTileAction) => void;
}

export const MeshGenerationTileButtons = (
  props: MeshGenerationTileButtonsProps,
) => {
  const { onAction } = props;

  const handleAction =
    (action: GenerationTileAction) => (e: React.MouseEvent) => {
      e.stopPropagation();
      onAction(e, action);
    };

  return (
    <TileButtonsContainer>
      <TileButton
        aria-label="Download"
        data-testid="btn-download"
        onClick={handleAction("DOWNLOAD")}
      >
        <Icon icon={faArrowDownToLine} fontSize="small" />
      </TileButton>
      <TileButton
        aria-label="View more options"
        data-testid="btn-more-options"
        onClick={handleAction("SHOW_MORE_OPTIONS")}
      >
        <Icon icon={faEllipsis} fontSize="small" />
      </TileButton>
    </TileButtonsContainer>
  );
};
